export const LOGO = 'Size120x120';
